import styled, { keyframes, css } from "styled-components";
import { headShake } from "react-animations";

const rubberBandAnimation = keyframes`${headShake}`;

export const ButtonStyle = styled.div`
  animation: ${(props) =>
    props.isLoading === true
      ? css`
          ${rubberBandAnimation} 1s ease-in-out
        `
      : ""};
`;
